import { contact } from './contact.config';

/**
 * Builds a `mailto:` URL for a blocked user to contact Hero support.
 * The email body is always in English (support triage convention).
 */
export function buildAccountBlockedSupportMailto(phone: string): string {
  const body = `My account is blocked with phone ${phone}`;
  return `mailto:${contact.customerCareEmail}?subject=${encodeURIComponent('Account blocked')}&body=${encodeURIComponent(body)}`;
}
